export enum HsaRestrictedReview {
  NotNeeded = "not_needed",
  Pending = "pending",
  Proceeded = "proceeded",
  Declined = "declined",
}
